import { AccountType } from "shared/types/accounts";
import { getAccountNameParts } from "utils/accounts";

type LegacyAccountNameFields = {
  name?: string;
  first_name?: string;
  last_name?: string;
};

export function getAccountLabel(account?: AccountType): string {
  if (!account) return "";

  const [, groupedOrAliasName] = getAccountNameParts(account);
  if (groupedOrAliasName) return groupedOrAliasName;

  if (account.displayLogin) return account.displayLogin;
  if (account.loginAlias) return account.loginAlias;
  if (account.login) return account.login;

  const legacyAccount = account as AccountType & LegacyAccountNameFields;
  const legacyFullName = [legacyAccount.first_name, legacyAccount.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (legacyFullName) return legacyFullName;
  if (legacyAccount.name) return legacyAccount.name;

  return account._id;
}
